<template>
  <div class="v-sim-card-table">
  <v-create-update-sim-card-form v-if="this.isShowModal"
                                 :sim-card-id="this.simCard"
                                 @close="closeModal" />

    <table v-else class="table">
      <thead>
        <tr>
          <!--1 row-->
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">Номер</th>
          <!--2 row-->
          <th scope="col">Оператор</th>
          <!--3 row-->
          <th scope="col">Серийный номер</th>
          <!--4 row-->
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">
            Дилер/Сотрудник
          </th>
          <th v-else scope="col">Дата активации</th>
          <!--5 row-->
          <th v-if="role === 'administrator'" scope="col"></th>
          <!--6 row-->
          <th v-if="role === 'administrator' || role === 'employee'" scope="col"></th>
          <!--7 row-->
          <th v-if="role === 'administrator'" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="card in this.simCardList" :key="card.id">
          <!--1 row-->
          <th v-if="role === 'administrator' || role === 'employee'" scope="row">
            {{ card.phone_number }}
            <span v-if="!card.in_use && card.activation_date" class="mr-1 badge badge-danger">
              a
            </span>
            <span v-else-if="!card.in_use" class="mr-1 badge badge-success">n</span>
            <span v-if="card.is_alerted" class="badge badge-danger">!</span>
          </th>

          <!--2 row-->
          <td>{{ card.provider.name }}</td>

          <!--3 row-->
          <td>{{ card.new_serial_number }}</td>

          <!--4 row-->
          <td v-if="card.dealer && role === 'administrator'
          || card.dealer && role === 'employee'">
            {{ card.dealer.last_name }}
            {{ card.dealer.first_name }}
          </td>
          <td v-else-if="card.employee && role === 'administrator'
          || card.employee && role === 'employee'">
            {{ card.employee.last_name }}
            {{ card.employee.first_name }}
          </td>
          <td v-else-if="role === 'administrator' || role === 'employee'">не закреплкна</td>

          <!--5 row-->
          <td v-if="role === 'dealer' && card.activation_date">
            {{ card.activation_date }}
          </td>
          <td v-else-if="role === 'dealer'">не активна</td>

          <!--6 row-->
          <td v-if="role === 'administrator' || role === 'employee'"
              @click="showModal(card.serial_number)">
            <font-awesome-icon :icon="['fa', 'cogs']"/>
          </td>

          <!--7 row-->
          <td v-if="role === 'administrator'"
              @click="deleteSIMCard(card.serial_number)">
            <font-awesome-icon :icon="['fa', 'trash']"/>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import cardAPI from '../../api/simCard';
import VCreateUpdateSimCardForm from '../forms/v-create-update-sim-card-form.vue';


export default {
  name: 'v-sim-card-table',
  components: { VCreateUpdateSimCardForm },
  props: ['simCardList', 'role'],
  data() {
    return {
      isShowModal: false,
      simCard: '',
    };
  },
  methods: {
    deleteSIMCard(simCardId) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить эту SIM карту?',
        buttons: [
          {
            title: 'Удалить SIM карту',
            handler: () => {
              cardAPI.deleteSIMCard(simCardId)
                .then(() => {
                  this.$emit('update');
                  this.$modal.hide('dialog');
                });
            },
          },
          {
            title: 'Закрыть',
            default: true,
          },
        ],
      });
    },
    showModal(card) {
      this.simCard = card;
      this.isShowModal = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.$emit('update');
    },
  },
};
</script>
